/*
  „Gabi · Komplet idealny” na karcie produktu (snippets/gabi-komplet-idealny.liquid).
  Opcje „Sam(a) …” i „W zestawie” w polu ceny, okienko „Komplet idealny” (<dialog>) z dwoma
  krokami o tym samym układzie (1. rzecz główna, 2. druga rzecz), ceny i dodanie obu rzeczy
  do koszyka jednym żądaniem.

  Kolor drugiej rzeczy to PODPOWIEDŹ, nie automatyczny wybór (decyzja Sebastiana 6.10.2026):
  kolor pasujący do koloru rzeczy głównej dostaje znacznik „pasuje”, ale nic nie zaznacza się
  samo. Zmiana koloru rzeczy głównej przesuwa podpowiedź, a wybranego koloru drugiej nie rusza.

  Kontrakt z funkcją rabatową — nie zmieniaj:
  - rabat na sztukę w groszach: min(round(cena × P / 100), cena − 1), zawsze dla rzeczy
    dobranej w okienku (cenaPoRabacie);
  - jedno POST /cart/add.js z items[]: rzecz główna z _komplet_glowny = K, druga z _komplet = K,
    po 1 sztuce; K = 8 znaków [a-z0-9] (losoweId).

  Funkcje czyste (KI) da się sprawdzić w Node: require('./gabi-komplet-idealny.js').
*/
(function () {
  'use strict';

  /* ---------- Funkcje czyste ---------- */

  function lc(t) {
    return String(t == null ? '' : t).trim().toLowerCase();
  }

  // Cena drugiej rzeczy po rabacie, w groszach (ten sam wzór co funkcja rabatowa).
  function cenaPoRabacie(cena, pct) {
    var rabat = Math.min(Math.round(cena * pct / 100), cena - 1);
    return cena - Math.max(rabat, 0);
  }

  function ceny(glowna, druga, pct) {
    var po = cenaPoRabacie(druga, pct);
    return { druga: po, osobno: glowna + druga, komplet: glowna + po, oszczedzasz: druga - po };
  }

  // Wyjątki kolorów z metapola sklepu: klucze i wartości bez wielkości liter.
  function normalizujWyjatki(raw) {
    var out = {};
    if (!raw || typeof raw !== 'object' || Array.isArray(raw)) return out;
    Object.keys(raw).forEach(function (k) {
      if (typeof raw[k] === 'string' && lc(raw[k])) out[lc(k)] = lc(raw[k]);
    });
    return out;
  }

  // Czy wartość `val` opcji `k` da się kupić przy pozostałych wybranych opcjach `sel`.
  function wartoscDostepna(prod, k, val, sel) {
    return prod.w.some(function (v) {
      if (!v.a || v.o[k] !== val) return false;
      for (var j = 0; j < v.o.length; j++) {
        if (j !== k && sel && sel[j] != null && sel[j] !== v.o[j]) return false;
      }
      return true;
    });
  }

  function wybierzWariant(prod, sel) {
    for (var i = 0; i < prod.w.length; i++) {
      var v = prod.w[i], ok = true;
      for (var j = 0; j < prod.o.length; j++) {
        if (sel[j] == null || v.o[j] !== sel[j]) { ok = false; break; }
      }
      if (ok) return v;
    }
    return null;
  }

  // Wariant gotowy do koszyka: wybrany, dostępny, droższy niż 1 gr.
  function gotowy(prod, sel) {
    var v = sel ? wybierzWariant(prod, sel) : null;
    return v && v.a && v.p > 1 ? v : null;
  }

  // Podpowiedź koloru drugiej rzeczy do koloru głównej: najpierw wyjątek z tabeli, potem ta sama
  // nazwa (bez wielkości liter). Tylko kolory dostępne. Brak = null. NIE jest wyborem.
  function kolorPasujacy(kolorGlowny, item, wyjatki) {
    if (item.ci < 0 || kolorGlowny == null) return null;
    var nazwa = lc(kolorGlowny), szukane = [];
    if (wyjatki && wyjatki[nazwa]) szukane.push(wyjatki[nazwa]);
    szukane.push(nazwa);
    var vals = item.o[item.ci].v;
    for (var s = 0; s < szukane.length; s++) {
      for (var i = 0; i < vals.length; i++) {
        if (lc(vals[i]) === szukane[s] && wartoscDostepna(item, item.ci, vals[i], null)) return vals[i];
      }
    }
    return null;
  }

  // Wybór startowy drugiej rzeczy: z góry tylko opcje z jedną wartością (kolor nigdy sam).
  function startowyWybor(item) {
    return item.o.map(function (opt) { return opt.v.length === 1 ? opt.v[0] : null; });
  }

  // Napis pod „W zestawie”: rodzaje z listy w mianowniku, bez powtórek, w kolejności listy,
  // „do wyboru: a, b lub c”. Nierozpoznane (puste) pomijamy; gdy nie zostaje nic — „dobierz drugą rzecz”.
  function polaczRodzaje(lista) {
    var u = [];
    (lista || []).forEach(function (r) {
      var t = String(r == null ? '' : r).trim();
      if (t && u.indexOf(t) < 0) u.push(t);
    });
    if (!u.length) return 'dobierz drugą rzecz';
    if (u.length === 1) return 'do wyboru: ' + u[0];
    return 'do wyboru: ' + u.slice(0, -1).join(', ') + ' lub ' + u[u.length - 1];
  }

  // Czego brakuje do wariantu: „Wybierz kolor czapki”, „Wybierz rozmiar”, „Wybierz inny kolor”.
  // gen = dopełniacz rodzaju („czapki”); pusty dla rzeczy nierozpoznanej.
  function brakujaca(prod, sel, gen) {
    var dop = gen ? ' ' + gen : '';
    for (var k = 0; k < prod.o.length; k++) {
      if (!sel || sel[k] == null) return 'Wybierz ' + (k === prod.ci ? 'kolor' : lc(prod.o[k].n)) + dop;
    }
    return 'Wybierz inny kolor' + dop;
  }

  // Napis przycisku = następny krok; gotowe = „Dodaj zestaw · <kwota>”.
  function napisPrzycisku(m, msel, it, bsel, kwota) {
    if (!gotowy(m, msel)) return brakujaca(m, msel, m.gen);
    if (!gotowy(it, bsel)) return brakujaca(it, bsel, it.gen);
    return 'Dodaj zestaw · ' + kwota;
  }

  // Linia stanu karty kroku. Gotowe: „Kolor: camel” (+ inne wybrane opcje). Brak koloru:
  // „Wybierz kolor”, a z `nieMa` (kolor głównej bez odpowiednika) „Wybierz kolor — camel nie ma”.
  function stanKroku(prod, sel, nieMa) {
    if (gotowy(prod, sel)) {
      var czesci = [];
      prod.o.forEach(function (opt, k) {
        if (k === prod.ci) czesci.unshift('Kolor: ' + sel[k]);
        else if (opt.v.length > 1) czesci.push(sel[k]);
      });
      return { gotowe: true, tekst: czesci.join(' · ') };
    }
    if (prod.ci >= 0 && (!sel || sel[prod.ci] == null)) {
      return { gotowe: false, tekst: 'Wybierz kolor' + (nieMa ? ' — ' + nieMa + ' nie ma' : '') };
    }
    return { gotowe: false, tekst: brakujaca(prod, sel, '') };
  }

  // Cena do pokazania: wybrany wariant, a bez niego najtańszy pasujący do wybranych opcji.
  function cenaDlaWyboru(prod, sel) {
    var v = wybierzWariant(prod, sel);
    if (v) return v.p;
    var min = null;
    prod.w.forEach(function (w) {
      for (var j = 0; j < w.o.length; j++) if (sel[j] != null && sel[j] !== w.o[j]) return;
      if (min === null || w.p < min) min = w.p;
    });
    return min === null ? najnizszaCena(prod) : min;
  }

  function najnizszaCena(prod) {
    var min = null;
    prod.w.forEach(function (v) { if (v.a && (min === null || v.p < min)) min = v.p; });
    if (min === null) prod.w.forEach(function (v) { if (min === null || v.p < min) min = v.p; });
    return min || 0;
  }

  function kompletOd(glowna, items, pct) {
    var min = null;
    items.forEach(function (it) {
      it.w.forEach(function (v) {
        if (!v.a) return;
        var po = cenaPoRabacie(v.p, pct);
        if (min === null || po < min) min = po;
      });
    });
    return glowna + (min || 0);
  }

  // Główne zdjęcie produktu; gdy produkt go nie ma — pierwsze zdjęcie wariantu.
  function zdjecieProduktu(prod) {
    if (prod.img) return prod.img;
    for (var i = 0; i < prod.w.length; i++) if (prod.w[i].img) return prod.w[i].img;
    return '';
  }

  // Zdjęcie rzeczy: wariant, potem dowolny wariant w wybranym kolorze, potem zdjęcie produktu.
  // inny = true, gdy kolor jest wybrany, a zdjęcia w tym kolorze nie ma.
  function zdjecie(prod, sel) {
    var v = wybierzWariant(prod, sel);
    if (v && v.img) return { src: v.img, inny: false };
    var kolor = prod.ci >= 0 ? sel[prod.ci] : null;
    if (kolor != null) {
      for (var i = 0; i < prod.w.length; i++) {
        if (prod.w[i].o[prod.ci] === kolor && prod.w[i].img) return { src: prod.w[i].img, inny: false };
      }
      return { src: zdjecieProduktu(prod), inny: true };
    }
    return { src: zdjecieProduktu(prod), inny: false };
  }

  // Czy rzecz czeka na wybór koloru (wtedy w kroku 2 neutralne pole zamiast zdjęcia).
  function czekaNaKolor(prod, sel) {
    return prod.ci >= 0 && prod.o[prod.ci].v.length > 1 && (!sel || sel[prod.ci] == null);
  }

  function losoweId(los) {
    var abc = 'abcdefghijklmnopqrstuvwxyz0123456789', out = '', bajty = null;
    if (!los && typeof crypto !== 'undefined' && crypto.getRandomValues) bajty = crypto.getRandomValues(new Uint8Array(8));
    for (var i = 0; i < 8; i++) {
      var r = bajty ? bajty[i] : Math.floor((los || Math.random)() * 256);
      out += abc.charAt(r % 36);
    }
    return out;
  }

  function formatMoney(cents, format) {
    var fmt = String(format || '{{amount_with_comma_separator}} zł').replace(/<[^>]*>/g, '');
    var re = /\{\{\s*(\w+)\s*\}\}/;
    var m = fmt.match(re);
    var value = Math.round(cents) / 100;
    function delim(n, dec, thou, sep) {
      var parts = n.toFixed(dec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
      return parts.join(sep);
    }
    var out;
    switch (m ? m[1] : 'amount') {
      case 'amount_no_decimals': out = delim(value, 0, ',', '.'); break;
      case 'amount_with_comma_separator': out = delim(value, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': out = delim(value, 0, '.', ','); break;
      case 'amount_with_space_separator': out = delim(value, 2, ' ', ','); break;
      case 'amount_with_apostrophe_separator': out = delim(value, 2, "'", '.'); break;
      default: out = delim(value, 2, ',', '.');
    }
    return m ? fmt.replace(re, out) : out;
  }

  var KI = {
    lc: lc, cenaPoRabacie: cenaPoRabacie, ceny: ceny, normalizujWyjatki: normalizujWyjatki,
    wartoscDostepna: wartoscDostepna, wybierzWariant: wybierzWariant, gotowy: gotowy,
    kolorPasujacy: kolorPasujacy, startowyWybor: startowyWybor, polaczRodzaje: polaczRodzaje,
    brakujaca: brakujaca, napisPrzycisku: napisPrzycisku, stanKroku: stanKroku,
    cenaDlaWyboru: cenaDlaWyboru, najnizszaCena: najnizszaCena, kompletOd: kompletOd,
    zdjecie: zdjecie, czekaNaKolor: czekaNaKolor, losoweId: losoweId, formatMoney: formatMoney
  };
  if (typeof module === 'object' && module.exports) module.exports = KI;
  if (typeof window === 'undefined' || typeof customElements === 'undefined') return;
  if (customElements.get('gabi-komplet-idealny')) return;

  /* ---------- Moduł na karcie ---------- */

  var ICON_CHECK = '<svg viewBox="0 0 16 16" aria-hidden="true" focusable="false"><path d="M3 8.5l3.2 3L13 4.5"/></svg>';
  var ICON_LUPA = '<svg class="gabi-ki-mini__lupa-ikona" viewBox="0 0 16 16" aria-hidden="true" focusable="false"><circle cx="7" cy="7" r="4.5"/><path d="M10.4 10.4L14 14M7 5v4M5 7h4"/></svg>';
  var ICON_KOLOR = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 3.5a8.5 8.5 0 1 0 0 17c1.2 0 1.8-.8 1.8-1.7 0-1.3-1.1-1.6-1.1-2.7 0-.9.7-1.6 1.6-1.6h2.1a4.1 4.1 0 0 0 4.1-4.1c0-3.8-3.8-6.9-8.5-6.9z"/><circle cx="7.6" cy="11" r="1.1"/><circle cx="10" cy="7.3" r="1.1"/><circle cx="14.4" cy="7.3" r="1.1"/></svg>';

  function esc(t) {
    return String(t == null ? '' : t).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  function rozmiar(url, w) {
    if (!url) return '';
    return /[?&]width=\d+/.test(url) ? url.replace(/([?&])width=\d+/, '$1width=' + w) : url + (url.indexOf('?') < 0 ? '?' : '&') + 'width=' + w;
  }

  function malyRuch() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  function fieldsetOpcji(picker, nazwa) {
    if (!picker) return null;
    var inputs = picker.querySelectorAll('input[type="radio"]');
    for (var i = 0; i < inputs.length; i++) {
      var name = inputs[i].name.trim();
      var cut = name.lastIndexOf('-');
      if ((cut > 0 ? name.slice(0, cut) : name) === nazwa) return inputs[i].closest('fieldset');
    }
    return null;
  }

  class GabiKompletIdealny extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      var raw = this.querySelector('[data-gabi-ki-dane]');
      try { this.d = JSON.parse(raw.textContent); } catch (e) { return; }
      if (!this.d || !this.d.m || !this.d.items || !this.d.items.length) return;
      this._ready = true;
      this.m = this.d.m;
      this.pct = this.d.pct;
      this.wyj = normalizujWyjatki(this.d.kolory);
      this.format = this.getAttribute('data-gabi-money-format');
      this.podpowiedz = polaczRodzaje(this.d.items.map(function (x) { return x.rz; }));
      this.tryb = 'sam';
      this.bi = 0;
      this.bsel = startowyWybor(this.item());
      this.szczegoly = false;
      this.zoom = null;
      this.mig = 0;
      this.info = this.closest('.product__content') || document;
      this.picker = this.info.querySelector('product-variant-selects');
      this.buy = this.info.querySelector('.product__buy-buttons');
      this.okno = this.querySelector('[data-gabi-ki-okno]');
      this.tresc = this.querySelector('[data-gabi-ki-tresc]');
      this.rachunek = this.querySelector('[data-gabi-ki-rachunek]');
      this.cta = this.querySelector('[data-gabi-ki-cta]');
      this.ctaOkno = this.querySelector('[data-gabi-ki-cta-okno]');
      this.cialo = this.querySelector('[data-gabi-ki-cialo]');
      this.zoomEl = this.querySelector('[data-gabi-ki-zoom]');
      this.msel = this.m.o.map(function (o) { return o.v.length === 1 ? o.v[0] : null; });
      this.odczytajGlowny();

      this.addEventListener('click', this.onClick.bind(this));
      if (this.picker) this.picker.addEventListener('change', this.onPickerChange.bind(this));
      if (this.okno) {
        this.okno.addEventListener('click', function (e) { if (e.target === this.okno) this.zamknij(); }.bind(this));
        this.okno.addEventListener('close', this.poZamknieciu.bind(this));
        // Escape przy otwartym powiększeniu zamyka tylko powiększenie, okienko zostaje.
        this.okno.addEventListener('cancel', function (e) {
          if (this.zoom) { e.preventDefault(); this.zamknijZoom(); }
        }.bind(this));
      }
      this.render();
    }

    fmt(c) { return formatMoney(c, this.format); }

    item() { return this.d.items[this.bi]; }

    kolorGlowny() { return this.m.ci >= 0 ? this.msel[this.m.ci] : null; }

    // Wybór rzeczy głównej czyta pole koloru i rozmiaru motywu (jedno źródło prawdy).
    odczytajGlowny() {
      var self = this;
      this.m.o.forEach(function (opt, k) {
        var fs = fieldsetOpcji(self.picker, opt.n);
        if (!fs) return;
        var c = fs.querySelector('input[type="radio"]:checked');
        self.msel[k] = c ? c.value : (opt.v.length === 1 ? opt.v[0] : null);
      });
    }

    ustawGlowny(k, val) {
      this.msel[k] = val;
      var fs = fieldsetOpcji(this.picker, this.m.o[k].n);
      if (fs) {
        var radios = fs.querySelectorAll('input[type="radio"]');
        for (var i = 0; i < radios.length; i++) {
          if (radios[i].value === val) {
            // Klik w pole motywu: zmienia zdjęcie, cenę i wariant na karcie (onPickerChange przerysuje moduł).
            if (!radios[i].checked) { radios[i].click(); return; }
            break;
          }
        }
      }
      this.render();
    }

    onPickerChange() {
      this.odczytajGlowny();
      this.render();
    }

    policz() {
      var glowna = cenaDlaWyboru(this.m, this.msel);
      var druga = cenaDlaWyboru(this.item(), this.bsel);
      return ceny(glowna, druga, this.pct);
    }

    ustawTryb(tryb) {
      if (tryb === 'komplet') {
        if (this.tryb !== 'komplet') {
          this.tryb = 'komplet';
          this.przelaczKarty();
        }
        this.otworz();
      } else if (this.tryb !== 'sam') {
        this.tryb = 'sam';
        this.przelaczKarty();
      }
      this.render();
    }

    przelaczKarty() {
      var komplet = this.tryb === 'komplet';
      var tryb = this.tryb;
      this.querySelectorAll('[data-gabi-ki-karta]').forEach(function (card) {
        var on = card.getAttribute('data-gabi-ki-karta') === tryb;
        card.classList.toggle('is-on', on);
        var head = card.querySelector('[data-gabi-ki-tryb]');
        if (head) head.setAttribute('aria-pressed', String(on));
      });
      this.cialo.hidden = !komplet;
      this.cta.hidden = !komplet;
      // Przycisk należy do modułu (Z7): w trybie kompletu przyciski motywu i pasek na telefonie znikają.
      if (this.buy) this.buy.classList.toggle('gabi-ki-ukryte', komplet);
      document.body.classList.toggle('gabi-ki-tryb', komplet);
      this.ukryjBlad();
    }

    otworz() {
      if (!this.okno || this.okno.open) return;
      this.powrot = document.activeElement;
      this.przewinNaGore = true;
      if (typeof this.okno.showModal === 'function') this.okno.showModal();
      else this.okno.setAttribute('open', '');
      document.documentElement.classList.add('gabi-ki-otwarte');
      this.render();
      var x = this.okno.querySelector('[data-gabi-ki-akcja="zamknij"]');
      if (x) x.focus({ preventScroll: true });
    }

    zamknij() {
      if (!this.okno || !this.okno.open) return;
      if (typeof this.okno.close === 'function') this.okno.close();
      else { this.okno.removeAttribute('open'); this.poZamknieciu(); }
    }

    poZamknieciu() {
      document.documentElement.classList.remove('gabi-ki-otwarte');
      this.zamknijZoom(true);
      this.mig = 0;
      this.render();
      var cel = this.querySelector('[data-gabi-ki-akcja="zmien"]') || this.powrot;
      if (cel && typeof cel.focus === 'function') cel.focus({ preventScroll: true });
    }

    /* ---------- Powiększenie miniatury (w obrębie okienka) ---------- */

    otworzZoom(krok) {
      var prod = krok === 1 ? this.m : this.item(), sel = krok === 1 ? this.msel : this.bsel;
      var f = zdjecie(prod, sel), przyklad = czekaNaKolor(prod, sel);
      if (!f.src || !this.zoomEl) return;
      var kolor = prod.ci >= 0 ? sel[prod.ci] : null;
      this.zoom = { krok: krok };
      var img = this.zoomEl.querySelector('img');
      img.src = rozmiar(f.src, 1000);
      img.alt = prod.t + (kolor ? ', kolor ' + kolor : '') + (!przyklad && f.inny ? ' (zdjęcie w innym kolorze)' : '');
      this.zoomEl.hidden = false;
      var x = this.zoomEl.querySelector('[data-gabi-ki-akcja="zoom-zamknij"]');
      if (x) x.focus({ preventScroll: true });
    }

    zamknijZoom(cicho) {
      if (!this.zoom) return;
      var krok = this.zoom.krok;
      this.zoom = null;
      if (this.zoomEl) this.zoomEl.hidden = true;
      if (cicho) return;
      var mini = this.tresc.querySelector('[data-gabi-ki-akcja="powieksz"][data-krok="' + krok + '"]');
      if (mini) mini.focus({ preventScroll: true });
    }

    onClick(e) {
      var el = e.target.closest('[data-gabi-ki-tryb], [data-gabi-ki-akcja]');
      if (!el || el.disabled || !this.contains(el)) return;
      if (el.hasAttribute('data-gabi-ki-tryb')) { this.ustawTryb(el.getAttribute('data-gabi-ki-tryb')); return; }
      var akcja = el.getAttribute('data-gabi-ki-akcja');
      var k = +el.getAttribute('data-k'), i = +el.getAttribute('data-i');
      this.ukryjBlad();
      if (akcja === 'zamknij') {
        this.zamknij();
      } else if (akcja === 'zmien') {
        this.ustawTryb('komplet');
      } else if (akcja === 'mopcja') {
        this.ustawGlowny(k, this.m.o[k].v[i]);
      } else if (akcja === 'bopcja') {
        this.bsel[k] = this.item().o[k].v[i];
        this.render();
      } else if (akcja === 'bitem') {
        if (i !== this.bi) {
          // Inna rzecz = czysty wybór: kolor trzeba wskazać (podpowiedź „pasuje” zostaje).
          this.bi = i;
          this.bsel = startowyWybor(this.item());
          this.szczegoly = false;
          this.przewinNaGore = true;
        }
        this.render();
      } else if (akcja === 'szczegoly') {
        this.szczegoly = !this.szczegoly;
        this.render();
      } else if (akcja === 'powieksz') {
        this.otworzZoom(+el.getAttribute('data-krok'));
      } else if (akcja === 'zoom-zamknij') {
        this.zamknijZoom();
      } else if (akcja === 'dodaj') {
        this.dodaj();
      }
    }

    /* ---------- Rysowanie ---------- */

    // Próbki jednej opcji. `pasuje` = wartość z podpowiedzią (znacznik „pasuje”, też w aria-label).
    przyciskiOpcji(prod, k, sel, akcja, pasuje) {
      var opt = prod.o[k], h = '';
      opt.v.forEach(function (val, i) {
        var ok = wartoscDostepna(prod, k, val, sel), on = sel[k] === val, p = pasuje != null && val === pasuje;
        var sw = k === prod.ci && opt.sw ? opt.sw[i] : '';
        h += '<span class="gabi-ki-opcja' + (p ? ' is-pasuje' : '') + '">';
        h += '<button type="button" class="' + (sw ? 'gabi-ki-sw' : 'gabi-ki-pill') + '" data-gabi-ki-akcja="' + akcja + '" data-k="' + k + '" data-i="' + i + '" aria-pressed="' + on + '" title="' + esc(val) + '" aria-label="' + esc(opt.n + ': ' + val + (p ? ', pasuje' : '') + (ok ? '' : ', niedostępny')) + '"' + (ok ? '' : ' disabled') + '>';
        h += sw ? '<i style="--gabi-ki-sw: ' + esc(sw) + ';"></i>' : esc(val);
        h += '</button>';
        if (p) h += '<span class="gabi-ki-opcja__pasuje" aria-hidden="true">pasuje</span>';
        h += '</span>';
      });
      return h;
    }

    wierszeOpcji(prod, sel, akcja, pasuje) {
      var h = '';
      for (var k = 0; k < prod.o.length; k++) {
        if (prod.o[k].v.length < 2) continue;
        h += '<div class="gabi-ki-okno__wiersz">' + this.przyciskiOpcji(prod, k, sel, akcja, k === prod.ci ? pasuje : null) + '</div>';
      }
      return h;
    }

    // Miniatura: zawsze zdjęcie (przycisk powiększenia, lupa przy rogu). Przed wyborem koloru —
    // zdjęcie produktu bez dopisku (decyzje Sebastiana 6.10.2026: puste pole wyglądało źle,
    // dopisek „przykładowy kolor” — niepotrzebny).
    miniatura(krok, prod, sel, puste, w) {
      var f = zdjecie(prod, sel), kolor = prod.ci >= 0 ? sel[prod.ci] : null;
      var img = f.src ? '<img src="' + esc(rozmiar(f.src, w)) + '" alt="" width="80" height="106">' : '';
      if (!f.src) return '<span class="gabi-ki-mini is-puste" role="img" aria-label="Brak zdjęcia">' + ICON_KOLOR + '</span>';
      var dopisek = (puste || czekaNaKolor(prod, sel)) ? '' : (f.inny ? 'zdjęcie w innym kolorze' : '');
      var inny = dopisek ? '<span class="gabi-ki-mini__inny">' + dopisek + '</span>' : '';
      if (krok === 0) return '<span class="gabi-ki-mini">' + img + '</span>';
      return '<button type="button" class="gabi-ki-mini" data-gabi-ki-akcja="powieksz" data-krok="' + krok + '" aria-label="' + esc('Powiększ zdjęcie: ' + prod.t + (kolor ? ', kolor ' + kolor : '')) + '">' + img + inny + '<span class="gabi-ki-mini__lupa">' + ICON_LUPA + '</span></button>';
    }

    opis(i) {
      this._opisy = this._opisy || {};
      if (this._opisy[i]) return this._opisy[i];
      var t = this.querySelector('template[data-gabi-ki-opis="' + i + '"]');
      var c = t ? t.content : null;
      function czesc(sel) { var el = c && c.querySelector(sel); return el ? el.innerHTML.trim() : ''; }
      this._opisy[i] = { zalety: czesc('[data-gabi-ki-zalety]'), tekst: czesc('[data-gabi-ki-tekst]'), wlasciwosci: czesc('[data-gabi-ki-wlasciwosci]') };
      return this._opisy[i];
    }

    // Karta kroku. Oba kroki mają ten sam układ: miniatura | nazwa, cena, linia stanu, kolory.
    karta(krok, prod, sel, o) {
      var stan = stanKroku(prod, sel, o.nieMa);
      var h = '<section class="gabi-ki-okno__krok ' + (stan.gotowe ? 'is-gotowe' : 'is-brak') + (this.mig === krok ? ' is-mig' : '') + '" data-krok="' + krok + '" aria-label="' + esc(krok + '. ' + (krok === 2 ? 'Druga rzecz: ' : '') + prod.t) + '">';
      h += this.miniatura(krok, prod, sel, o.puste, 200);
      h += '<div class="gabi-ki-okno__k-info">';
      if (krok === 2) h += '<p class="gabi-ki-okno__k-etykieta">2. Druga rzecz</p>';
      h += '<p class="gabi-ki-okno__k-nazwa">' + (krok === 1 ? '<span>1.</span> ' : '') + esc(prod.t) + '</p>';
      h += '<p class="gabi-ki-okno__k-cena">' + o.cena + '</p>';
      h += '<p class="gabi-ki-okno__stan">' + (stan.gotowe ? ICON_CHECK : '') + esc(stan.tekst) + '</p>';
      h += this.wierszeOpcji(prod, sel, krok === 1 ? 'mopcja' : 'bopcja', o.pasuje);
      if (o.szczegoly) h += o.szczegoly.link;
      h += '</div>';
      if (o.szczegoly) h += o.szczegoly.tresc;
      h += '</section>';
      return h;
    }

    // Link „Szczegóły” w kroku 2 i rozwinięta treść (zalety, krótki opis, właściwości).
    szczegolyHtml() {
      var o = this.opis(this.bi);
      if (!o.zalety && !o.tekst && !o.wlasciwosci) return null;
      var id = (this.okno && this.okno.id ? this.okno.id : 'GabiKiOkno') + '-szczegoly';
      var link = '<button type="button" class="gabi-ki__link gabi-ki-okno__szczegoly-link" data-gabi-ki-akcja="szczegoly" aria-expanded="' + this.szczegoly + '" aria-controls="' + id + '">' + (this.szczegoly ? 'Zwiń szczegóły' : 'Szczegóły') + '</button>';
      var tresc = '';
      if (this.szczegoly) {
        tresc = '<div class="gabi-ki-okno__szczegoly rte" id="' + id + '">';
        if (o.zalety) tresc += '<ul class="gabi-ki-okno__zalety">' + o.zalety.replace(/<li>/g, '<li>' + ICON_CHECK) + '</ul>';
        if (o.tekst) tresc += o.tekst;
        if (o.wlasciwosci) tresc += o.wlasciwosci;
        tresc += '</div>';
      }
      return { link: link, tresc: tresc };
    }

    renderCialo(c) {
      var it = this.item(), sel = this.bsel;
      var kolor = it.ci >= 0 ? sel[it.ci] : null;
      var h = '<div class="gabi-ki__wybor">' + this.miniatura(0, it, sel, czekaNaKolor(it, sel), 120);
      h += '<div><p class="gabi-ki__wybor-nazwa">' + esc(it.t) + '</p>';
      if (czekaNaKolor(it, sel)) h += '<p class="gabi-ki__wybor-kolor is-brak">wybierz kolor</p>';
      else if (kolor) h += '<p class="gabi-ki__wybor-kolor">Kolor: ' + esc(kolor) + '</p>';
      h += '<p class="gabi-ki__wybor-cena"><b>' + this.fmt(c.druga) + '</b> <s>' + this.fmt(c.druga + c.oszczedzasz) + '</s></p></div>';
      h += '<button type="button" class="gabi-ki__link" data-gabi-ki-akcja="zmien">Zmień</button></div>';
      this.cialo.innerHTML = h;
    }

    renderOkno(c) {
      var m = this.m, it = this.item(), sel = this.bsel, self = this;
      var mKolor = this.kolorGlowny();
      var pasuje = kolorPasujacy(mKolor, it, this.wyj);
      var wieleKolorow = it.ci >= 0 && it.o[it.ci].v.length > 1;
      var glowna = c.osobno - c.druga - c.oszczedzasz;

      var h = this.karta(1, m, this.msel, { cena: this.fmt(glowna), puste: false });
      h += this.karta(2, it, sel, {
        cena: '<b>' + this.fmt(c.druga) + '</b> <s>' + this.fmt(c.druga + c.oszczedzasz) + '</s>',
        puste: czekaNaKolor(it, sel),
        pasuje: pasuje,
        nieMa: wieleKolorow && mKolor && !pasuje ? mKolor : '',
        szczegoly: this.szczegolyHtml()
      });

      if (this.d.items.length > 1) {
        h += '<div class="gabi-ki-okno__inne-blok"><p class="gabi-ki-okno__etykieta">Inne do wyboru</p><div class="gabi-ki-okno__inne">';
        this.d.items.forEach(function (x, i) {
          if (i === self.bi) return;
          var f = zdjecie(x, startowyWybor(x));
          h += '<button type="button" class="gabi-ki-okno__rzecz" data-gabi-ki-akcja="bitem" data-i="' + i + '" aria-label="' + esc('Wybierz zamiast: ' + x.t + ', ' + self.fmt(cenaPoRabacie(najnizszaCena(x), self.pct))) + '">';
          h += '<img src="' + esc(rozmiar(f.src, 160)) + '" alt="" width="56" height="74" loading="lazy">';
          h += '<span class="gabi-ki-okno__r-nazwa">' + esc(x.t) + '</span>';
          h += '<span class="gabi-ki-okno__r-cena">' + self.fmt(cenaPoRabacie(najnizszaCena(x), self.pct)) + '</span></button>';
        });
        h += '</div></div>';
      }

      var przewin = this.tresc.scrollTop;
      this.tresc.innerHTML = h;
      this.tresc.scrollTop = this.przewinNaGore ? 0 : przewin;
      this.przewinNaGore = false;

      this.rachunek.innerHTML = '<div><dt>Osobno</dt><dd>' + this.fmt(c.osobno) + '</dd></div>' +
        '<div class="is-razem"><dt>W zestawie</dt><dd>' + this.fmt(c.komplet) + '</dd></div>' +
        '<div class="is-zysk"><dt>Oszczędzasz</dt><dd>' + this.fmt(c.oszczedzasz) + '</dd></div>';
    }

    render() {
      // Po przerysowaniu fokus wraca na ten sam przycisk (klawiatura i czytniki ekranu).
      var a = document.activeElement, fokus = null;
      if (a && this.contains(a) && a.hasAttribute('data-gabi-ki-akcja')) {
        fokus = '[data-gabi-ki-akcja="' + a.getAttribute('data-gabi-ki-akcja') + '"]';
        ['data-k', 'data-i', 'data-krok'].forEach(function (n) {
          if (a.hasAttribute(n)) fokus += '[' + n + '="' + a.getAttribute(n) + '"]';
        });
      }

      var c = this.policz(), komplet = this.tryb === 'komplet';
      var glownaWybrana = !!wybierzWariant(this.m, this.msel);
      var samaCena = this.querySelector('[data-gabi-ki-cena-sam]');
      var odGlowna = c.osobno - c.druga - c.oszczedzasz;
      var rozne = this.m.w.some(function (v) { return v.p !== this.m.w[0].p; }, this);
      if (samaCena) samaCena.textContent = (!glownaWybrana && rozne ? 'od ' : '') + this.fmt(odGlowna);
      var sub = this.querySelector('[data-gabi-ki-sub]');
      if (sub) sub.textContent = komplet ? 'oszczędzasz ' + this.fmt(c.oszczedzasz) : this.podpowiedz;
      var cenaK = this.querySelector('[data-gabi-ki-cena-komplet]');
      if (cenaK) cenaK.textContent = komplet ? this.fmt(c.komplet) : 'od ' + this.fmt(kompletOd(odGlowna, this.d.items, this.pct));
      if (komplet) this.renderCialo(c);

      var napis = this.dodano ? 'Dodano zestaw ✓' : napisPrzycisku(this.m, this.msel, this.item(), this.bsel, this.fmt(c.komplet));
      [this.cta, this.ctaOkno].forEach(function (b) { if (b) b.textContent = napis; });
      if (this.okno && this.okno.open) this.renderOkno(c);

      if (fokus) {
        var el = this.querySelector(fokus);
        if (el && el !== document.activeElement) el.focus({ preventScroll: true });
      }
    }

    /* ---------- Koszyk ---------- */

    pokazBlad(msg) {
      var el = this.querySelector(this.okno && this.okno.open ? '[data-gabi-ki-blad-okno]' : '[data-gabi-ki-blad]');
      if (!el) return;
      el.textContent = msg;
      el.hidden = false;
    }

    ukryjBlad() {
      this.querySelectorAll('[data-gabi-ki-blad], [data-gabi-ki-blad-okno]').forEach(function (el) { el.hidden = true; });
    }

    // Przycisk przy brakach: przewija do pierwszej niepełnej karty i krótko ją podkreśla.
    wskazBrak() {
      var krok = gotowy(this.m, this.msel) ? 2 : 1, self = this;
      if (!this.okno) return;
      this.mig = krok;
      if (!this.okno.open) this.otworz();
      else this.render();
      var karta = this.tresc.querySelector('[data-krok="' + krok + '"]');
      if (karta) karta.scrollIntoView({ block: 'nearest', behavior: malyRuch() ? 'auto' : 'smooth' });
      clearTimeout(this.migT);
      this.migT = setTimeout(function () {
        self.mig = 0;
        var el = self.tresc.querySelector('.is-mig');
        if (el) el.classList.remove('is-mig');
      }, 1600);
    }

    analityka(gv, dv, c) {
      var dl = window.DL, map = window.__dlPdpVariants || {};
      if (!dl || typeof dl.push !== 'function') return;
      var it = this.item(), list = [];
      var build = typeof dl.buildItem === 'function' ? dl.buildItem : function (x) { return x; };
      if (map[gv.id]) list.push(build(Object.assign({}, map[gv.id], { quantity: 1 })));
      list.push(build({
        item_id: String(dv.id), item_name: it.t, price: c.druga / 100, discount: c.oszczedzasz / 100,
        item_variant: lc(dv.o.join(' / ')), item_color: lc(dv.o[0]), item_size: dv.o[1] != null ? lc(dv.o[1]) : '',
        item_category: it.cat, item_category2: it.cat2, quantity: 1
      }));
      dl.push('add_to_cart', {
        component: 'komplet_idealny',
        ecommerce: { currency: (window.__dlGlobals && window.__dlGlobals.currency) || '', value: c.komplet / 100, items: list }
      });
    }

    dodaj() {
      if (this.busy) return;
      var gv = gotowy(this.m, this.msel), dv = gotowy(this.item(), this.bsel);
      if (!gv || !dv) { this.wskazBrak(); return; }
      var it = this.item(), c = ceny(gv.p, dv.p, this.pct), k = losoweId();
      var map = window.__dlPdpVariants || {};

      var glowneProps = { _komplet_glowny: k };
      var d = map[gv.id];
      if (d) {
        var extra = { _dl_color: d.item_color, _dl_size: d.item_size, _dl_den: d.item_den, _dl_cat: d.item_category, _dl_cat2: d.item_category2, _dl_low30: d.item_lowest_price_30d };
        Object.keys(extra).forEach(function (key) { if (extra[key] != null && extra[key] !== '' && extra[key] !== false) glowneProps[key] = String(extra[key]); });
      }
      var drugieProps = { _komplet: k };
      var dExtra = { _dl_color: lc(dv.o[0]), _dl_size: dv.o[1] != null ? lc(dv.o[1]) : '', _dl_cat: it.cat, _dl_cat2: it.cat2 };
      Object.keys(dExtra).forEach(function (key) { if (dExtra[key]) drugieProps[key] = String(dExtra[key]); });

      var items = [
        { id: gv.id, quantity: 1, properties: glowneProps },
        { id: dv.id, quantity: 1, properties: drugieProps }
      ];
      var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      var payload = { items: items };
      if (cart && typeof cart.getSectionsToRender === 'function') {
        payload.sections = cart.getSectionsToRender().map(function (s) { return s.section; });
        payload.sections_url = window.location.pathname;
      }
      var url = ((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js';
      var self = this, przyciski = [this.cta, this.ctaOkno];
      this.busy = true;
      przyciski.forEach(function (b) { if (b) b.classList.add('loading'); });
      fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (res) { return res.json().then(function (json) { return { ok: res.ok, json: json }; }); })
        .then(function (r) {
          if (!r.ok || r.json.status) {
            self.pokazBlad(r.json.description || r.json.message || 'Nie udało się dodać zestawu. Spróbuj jeszcze raz.');
            return;
          }
          self.analityka(gv, dv, c);
          if (!cart || typeof cart.renderContents !== 'function') {
            window.location.href = (window.routes && window.routes.cart_url) || '/cart';
            return;
          }
          self.zamknij();
          cart.renderContents(r.json);
          self.dodano = true;
          self.render();
          setTimeout(function () { self.dodano = false; self.render(); }, 1800);
        })
        .catch(function () {
          self.pokazBlad('Nie udało się dodać zestawu. Sprawdź połączenie i spróbuj jeszcze raz.');
        })
        .finally(function () {
          self.busy = false;
          przyciski.forEach(function (b) { if (b) b.classList.remove('loading'); });
        });
    }
  }

  customElements.define('gabi-komplet-idealny', GabiKompletIdealny);
})();
